import { ShieldCheck, Award, BookMarked, Sparkles } from "lucide-react";

export default function TrustBadges({ listing, compact = false }) {
  const badges = [];
  if (listing.vanturis_verified) badges.push({ icon: ShieldCheck, label: "Verified" });
  if (listing.vanturis_certified) badges.push({ icon: Award, label: "Certified" });
  if (listing.vanturis_approved && !compact) badges.push({ icon: Sparkles, label: "Approved" });
  if (badges.length === 0) return null;

  return (
    <div className={`flex ${compact ? "flex-col" : "flex-wrap"} gap-2`}>
      {badges.map((b) => {
        const Icon = b.icon;
        return (
          <div
            key={b.label}
            className="trust-badge bg-ivory/90 backdrop-blur-sm"
            data-testid={`badge-${b.label.toLowerCase()}`}
          >
            <Icon className="w-3 h-3" strokeWidth={1.5} />
            <span>Vanturis {b.label}</span>
          </div>
        );
      })}
    </div>
  );
}
